module.exports = __webpack_public_path__ + "img/119b795.jpg";